import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ErrorHandlerInterceptorService} from '../interceptors/error-handler-interceptor.service';
import {LoaderInterceptorService} from '../interceptors/loader-interceptor.service';
import {MsalInterceptor} from "@azure/msal-angular";
import {VectorBffAuthInterceptorService} from '../interceptors/vector-bff-auth-interceptor.service';

export const httpInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: VectorBffAuthInterceptorService, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptorService, multi: true }
];
